<template>
  <div id="app">
    <div v-if="isLoading" class="page-loader">
      <div class="loader-inner">
        <div class="loader-ring" aria-hidden="true"></div>
        <p class="loader-title">Diamond Gym</p>
        <p class="loader-subtitle">Pripravujeme tréningový zážitok...</p>
      </div>
    </div>

    <HeaderComponent />
    <router-view
      :trainers="trainers"
      @submit-form="submitForm"
    />
  </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { WOW } from 'wowjs'
import HeaderComponent from './components/HeaderComponent.vue'

export default {
  name: "App",
  components: {
    HeaderComponent
  },
  setup() {
    const isLoading = ref(true)
    let loaderTimer

    const handleLoad = () => {
      if (loaderTimer) {
        clearTimeout(loaderTimer)
      }
      loaderTimer = window.setTimeout(() => {
        isLoading.value = false
      }, 250)
    }

    const trainers = ref([
      { name: 'Arben', image: require('@/assets/images/5.webp') },
      { name: 'Soňa', image: require('@/assets/images/sona-rusenova.webp') },
      { name: 'Lukáš', image: require('@/assets/images/8.webp') },
      { name: 'Klaudia', image: require('@/assets/images/2.webp') },
      { name: 'Andrej', image: require('@/assets/images/7.webp') },
      { name: 'Stefi', image: require('@/assets/images/3.webp') },
      { name: 'Mário', image: require('@/assets/images/mario-vesely.webp') },
      { name: 'Eliška', image: require('@/assets/images/6.webp') },
      { name: 'Samuel', image: require('@/assets/images/samuel-cukan.webp') },
      { name: 'Zuzana', image: require('@/assets/images/zuz-pataky.webp') },
    ])

    onMounted(() => {
      window.addEventListener('load', handleLoad)
      if (document.readyState === 'complete') {
        handleLoad()
      }
      new WOW().init()
    })

    onBeforeUnmount(() => {
      window.removeEventListener('load', handleLoad)
      if (loaderTimer) {
        clearTimeout(loaderTimer)
      }
    })

    const submitForm = (contactFormData) => {
      console.log("Contact form submitted:", contactFormData)
      alert("Message sent!")
    }

    return {
      trainers,
      submitForm,
      isLoading,
    }
  }
}
</script>

<style scoped>
.page-loader {
  position: fixed;
  inset: 0;
  background: radial-gradient(circle at 20% 20%, rgba(232, 185, 35, 0.2), rgba(0, 0, 0, 0.9)), #050505;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  color: #e8b923;
  pointer-events: auto;
}

.loader-inner {
  text-align: center;
}

.loader-ring {
  width: 68px;
  height: 68px;
  margin: 0 auto 16px;
  border: 4px solid rgba(232, 185, 35, 0.2);
  border-top-color: #e8b923;
  border-radius: 50%;
  animation: loader-spin 0.9s linear infinite;
}

.loader-title {
  font-size: 22px;
  letter-spacing: 0.15em;
  text-transform: uppercase;
}

.loader-subtitle {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin-top: 6px;
}

@keyframes loader-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 640px) {
  .loader-title {
    font-size: 18px;
  }

  .loader-ring {
    width: 52px;
    height: 52px;
  }
}
</style>
